import { loadable } from '@shared/core/loadableFromNamedExport';
import { ThingsToDoGrabber } from './ThingsToDoSidebar';
import { THINGS_TO_DO_SCHEMA_URL, THINGS_TO_DO_COMPONENT_TYPE } from './ThingsToDo.constants';
import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';

// Lazy load view components
const ThingsToDoAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorThingsToDoAdd" */ './ThingsToDoSidebar'), 'ThingsToDoAdd');

const ThingsToDoEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorThingsToDoEdit" */ './ThingsToDoEdit'), 'ThingsToDoEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const ThingsToDoConfig: AdminJsonComponentConfig = {
  schemaUrl: THINGS_TO_DO_SCHEMA_URL,
  componentType: THINGS_TO_DO_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: ThingsToDoAdd,
    dragComponentView: ThingsToDoGrabber,
    editComponentView: ThingsToDoEdit,
    createComponentView: ThingsToDoEdit,
  },
};
